// extracted by mini-css-extract-plugin
export default {"container":"SectionLayout-module--container--SL60Z","padding":"SectionLayout-module--padding--Yc6yL","item":"SectionLayout-module--item--yFr4y"};